import { useEffect, useState } from "react";
import {
  Moon,
  Sun,
  Menu,
  ChevronDown,
  X,
} from "lucide-react";
// import "./WinnersLand.css";
import { useTheme, useCountUp } from "../WinnerLand/useTheme";

export function WinnersHeader() {
  const [scrolled, setScrolled] = useState(false);
  const [mobile, setMobile] = useState(false);
  const { dark, toggle } = useTheme();

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 20);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const links = ["Home", "Properties", "Community", "About", "Blog", "Careers"];

  return (
    <header className="wsh-header" data-scrolled={scrolled}>
      <div className="wsh-logo">
        <span className="wsh-logo-dot">W</span>
        Winners
      </div>

      <nav className="wsh-nav">
        {links.map((l) => (
          <a key={l} className="wsh-link">{l}</a>
        ))}
        <a className="wsh-link" style={{ display: "inline-flex", alignItems: "center", gap: 4 }}>
          Cities <ChevronDown size={14} />
        </a>
      </nav>

      <div className="wsh-actions">
        <button className="wsh-cta">Join now</button>
        <button className="wsh-theme-btn" onClick={toggle} aria-label="Toggle theme">
          {dark ? <Sun size={18} /> : <Moon size={18} />}
        </button>
        <button className="wsh-mobile-btn" onClick={() => setMobile((m) => !m)} aria-label="Menu">
          {mobile ? <X size={20} /> : <Menu size={20} />}
        </button>
      </div>

      {mobile && (
        <div className="wsh-mobile-panel">
          {links.map((l) => <a key={l} className="wsh-link">{l}</a>)}
          <button className="wsh-cta" style={{ marginTop: 8 }}>Join now</button>
        </div>
      )}
    </header>
  );
}